import { GET_GUEST_COMMENTS_DATA } from "../../../constants";

export function getGuestComments(data) {
    return {
        type: GET_GUEST_COMMENTS_DATA,
        data,
    };
}
